import React from "react";
import leftsm from "../assets/icons/leftsm.svg";

const Experiences = () => {
  const content = [
    {
      title: "IT Developer (Backend)",
      company: "PT Tower Bersama Infrastructure Tbk - Jakarta, Indonesia",
      date: "Nov 2025 - Present",
      team: "Bussiness Support - Software Engineer",
      description:
        "PT Tower Besama Infrastructure Tbk (TBIG) is one of the largest telecommunications infrastructure providers in indonesia, operating in the field of tower rental, fiber optic networks, and signal antennas for cellular operators.",
      techStack: "C#, ASP.NET, .NET, Bootstrap, SQL Server",
      tasks: [
        "Develop and optimize the company's Risk Register system, focusing on building a stable backend architecture.",
        "Design and implement complex stored procedures and advanced database functions to process large risk data, ensure data integrity, and accelerate query response times.",
        "Build and integrate dynamic multi-level approval workflows, facilitating seamless inter-divisional coordination in the enterprise risk mitigation process. "
      ]
    },
    {
      title: "IT Developer",
      company: "PT Pertamina Hulu Rokan - Jakarta, Indonesia",
      date: "Sep 2024 - Sep 2025",
      team: "Bussiness & Technical Application - Software Engineer",
      description:
        "PT Pertamina Hulu Rokan is a subsidiary of Pertamina, Indonesia's largest state-owned oil and gas company, focusing on upstream oil and gas operations. The company manages one of the country’s largest oil-producing fields.",
      techStack: "C#, ASP.NET MVC, .NET, Bootstrap, SQL Server",
      tasks: [
        "Developed internal applications using C#, ASP.NET MVC, and SQL Server to support upstream oil operations.",
        "Contribute to the SAP QRA (Query, Reporting & Analysis) redesign process to improve efficiency and user experience in using the application system. ",
        "Analyze business and technical requirements to ensure the solution implemented is in line with company standards. "
      ]
    },
    {
      title: "Mentee of Hacker Backend",
      company: "Digistar Club by Telkom Indonesia - Jakarta, Indonesia (Online)",
      date: "Aug 2024 - Present",
      team: "Backend Engineer",
      description:
        "Digistar Club is a selective talent development program run by Telkom Indonesia, designed to mentor and train participants in software development.",
      techStack: "JavaScript, Express.js, Node.js, PostgreSQL, Git, Next.js",
      tasks: [
        "Built and optimized backend features using JavaScript, Express.js, and PostgreSQL for PaDi UMKM application.",
        "Contributed to the development of Next.js-based projects, enhancing the performance of backend services.",
        "Participated in peer code reviews and contributed to best practices for Git-based collaboration."
      ]
    },
    {
      title: "Golang Software Engineer Trainee",
      company: "Enigma Camp - Jakarta, Indonesia (Online)",
      date: "Dec 2023 - Feb 2024",
      team: "Software Engineer",
      description:
        "Enigma Camp is an Indonesian tech bootcamp that trains individuals in software engineering with a focus on hands-on learning and industry projects.",
      techStack: "Golang, Gin, PostgreSQL, Git, Docker",
      tasks: [
        "Created a RESTful API for a point-of-sale system with integrated Midtrans payment gateway using Golang and Gin.",
        "Utilized Docker to containerize applications, ensuring smooth deployment and scalability.",
        "Worked in a team using GitLab, practicing collaborative development and version control."
      ]
    },
    {
      title: "Cloud Computing Learning Path Student",
      company:
        "Bangkit Academy by Google, GoTo, Traveloka - Jakarta, Indonesia (Online)",
      date: "Feb 2022 - Jul 2022",
      team: "Cloud Computing Engineer",
      description:
        "Bangkit Academy is a prestigious educational program in Indonesia supported by Google, Tokopedia, Gojek, and Traveloka, providing intensive learning paths in cloud computing, machine learning, and mobile development.",
      techStack: "JavaScript, Node.js, Express.js, Git, Firebase, Docker, GCP",
      tasks: [
        "Developed and deployed a RESTful API for a mobile application using Express.js and Firebase.",
        "Learned cloud fundamentals and soft skills, including communication and teamwork, to enhance overall project performance.",
        "Deployed a machine learning model using Flask and Docker on Google Cloud Run."
      ]
    },
    {
      title: "Assistant Lecturer of Data Structure",
      company: "Tadulako University - Palu, Indonesia",
      date: "Mar 2022 - May 2022",
      team: "Data Structure Assistant Lecturer",
      description:
        "Tadulako University is a public university in Indonesia, and the Data Structure course is part of the core curriculum for Informatics Engineering students.",
      techStack: "C++",
      tasks: [
        "Assisted the lead lecturer in delivering lectures, grading assignments, and preparing teaching materials for students.",
        "Led practical coding sessions, guiding students in implementing various data structures such as arrays, linked lists, stacks, queues, and trees.",
        "Provided additional tutorials to clarify concepts and worked with struggling students to improve their coding skills."
      ]
    },
    {
      title: "Software Developer Internship",
      company: "CV. SIC Yogyakarta - Yogyakarta, Indonesia",
      date: "Jul 2018 - Nov 2018",
      team: "Software Developer",
      description:
        "CV. SIC Yogyakarta is a business entity engaged in multimedia, computer, and software engineering.",
      techStack: "PHP, JavaScript, MySQL",
      tasks: [
        "Developed web applications using PHP, JavaScript, and MySQL to meet client requirements.",
        "Optimized and maintained computers, ensuring systems ran efficiently.",
        "Designed and built a 3D Mario Bros game using Unity3D."
      ]
    }
  ];

  return (
    <div id="experiences" className="py-6 md:p-20 cursor-default">
      <h1 className="font-bold text-[#FF6812] text-xl md:text-4xl pb-2 md:pb-6">
        Experiences
      </h1>
      <p className="text-sm md:text-2xl pb-6 md:pb-12">
      I have some very valuable experience in the IT field as a <span className="text-[#FF6812]">software engineer</span>.
      </p>

      <div className="flex flex-col gap-6">
        {content.map((exp, index) => (
          <div
            key={index}
            className="bg-[#202020] rounded-xl p-6 transition ease-in-out delay-150 hover:-translate-y-0 hover:scale-110 duration-300 cursor-pointer"
          >
            <div className="flex justify-between items-start">
              <div>
                <h1 className="text-2xl md:text-4xl font-extrabold">
                  {exp.title}
                </h1>
                <p className="text-base md:text-lg mt-2">{exp.company}</p>
              </div>
              <img src={leftsm} alt="" className="w-6 md:w-8" />
            </div>
            <div className="my-4 md:my-8">
              <p>{exp.date}</p>
              <p className="text-[#FF6812] font-semibold">{exp.team}</p>
            </div>
            <p className="text-xs md:text-base">
              {exp.description}
              <br />
              <br />
              <b>Tech Stack:</b> {exp.techStack}
              <br />
              {exp.tasks.map((task, taskIndex) => (
                <span key={taskIndex}>
                  ● {task}
                  <br />
                </span>
              ))}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Experiences;
